import Vue from 'vue'
import VueRouter from 'vue-router'
import homePage from '../views/homePage.vue' //首页
import aboutUs from '../views/aboutUs.vue' //关于我们
import solution from '../views/solution.vue' //解决方案
import caseAndUse from '../views/caseAndUse.vue' //案例及使用
import newsCenter from '../views/newsCenter.vue' //新闻中心
import contactUs from '../views/contactUs.vue' //联系我们
import menu from '../components/publicCom/mobileMenu.vue' //移动端菜单

Vue.use(VueRouter)

const routes = [{
        path: '/',
        // name: 'Home',
        component: homePage
    },
    {
        path: "/aboutUs",
        component: aboutUs
    },
    {
        path: "/solution",
        component: solution
    },
    {
        path: "/caseAndUse",
        component: caseAndUse
    },
    {
        path: "/newsCenter",
        component: newsCenter
    },
    {
        path: "/contactUs",
        component: contactUs
    },
    {
        path: "/menu",
        component: menu
    }
]

const router = new VueRouter({
    routes,
    mode: 'hash', // 访问路径不带#号
    base: '/'
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js